import React, { Component } from 'react';
import styled, { css } from 'styled-components'
import { PageContainer, Header, PageTitle, Button, TopicList, Topic} from '../components/styledComponents';
import { topics } from '../data/topics'

const Section = styled.div`
	width: 100%;
	height: 200px;
	margin-bottom: 40px;
`
const SectionTitle = styled.p`
	text-align: left;
	color: white;
  padding: 11px 15px;
  border-radius: 5px;
  background: #7e453e;
  margin: 0px -20px 10px -20px;
`

const BottomBar = styled.div`
	display: flex;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
`

const BarButton = styled(Button)`
	background: white;
  color: #7e453e;
  font-weight: bold;
  border-radius: 0;
  border-top: 1px solid #7e453e;
  border-right: 1px solid #7e453e;
  border-bottom: 4px solid transparent;
  cursor: default;

  ${props => props.active && css`
  	cursor: pointer;
  	border-bottom: 4px solid #7e453e;
  `}
`

class Dashboard extends Component {
	createTopic = (topic, index) => {
		return (<Topic
		  reduce={index === 10}
	      img={topic.img}
	      key={index}
	      selected={topic.selected}
	      onClick={() => {
	      	if (index === 10) {
	      		return
	      	}
	        this.props.chooseTopic(topic.title)
	      }}> 
	      <div>
	        <span>{topic.title}</span>
	      </div>      
	    </Topic>)
	} 
	render() {
		const topicList = topics.filter(topic => topic.title !== (this.props.topic || 'Creativity')).slice(0, 2).map(this.createTopic)
		const myTopic = topics.filter(topic => topic.title === (this.props.topic || 'Creativity')).map(this.createTopic)
	  	const newTopic = this.createTopic({
	      title: 'Add New',
	      selected: false,
	      img: 'icons/add.svg'
    	}, 10)
		return (
			<PageContainer>
		        <Header>
		          <PageTitle>My Dashboard</PageTitle>
		        </Header>
		        <Section>
		        	<SectionTitle>My Courses</SectionTitle>
		        	<TopicList>
		        		{[myTopic, newTopic]}
		        	</TopicList>
		       	</Section>
		       	<Section>
		        	<SectionTitle>Trending Topics</SectionTitle>
		        	<TopicList>
		        		{topicList}
		        	</TopicList>	
		       	</Section>
		       	<BottomBar>
		       		<BarButton active>Home</BarButton>
		       		<BarButton>Community</BarButton>
		       	</BottomBar>
		    </PageContainer>
		)
	}
}

export default Dashboard;
